import * as React from "react";
import type { SVGProps } from "react";
const SvgEsim = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21 6.83a2 2 0 0 0-.59-1.42L16.6 1.6a2 2 0 0 0-1.43-.6H6a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6.83ZM6 21h12a1 1 0 0 0 1-1V6.83L15.17 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1Z"
    />
    <path
      fill="currentColor"
      d="M12.63 18.2a6.06 6.06 0 0 1-2.7-.56 4.21 4.21 0 0 1-1.72-1.6c-.4-.7-.6-1.51-.6-2.45 0-.91.2-1.71.58-2.4.38-.69.92-1.23 1.6-1.61.7-.4 1.48-.6 2.36-.6.63 0 1.21.11 1.73.33a3.74 3.74 0 0 1 2.18 2.32c.19.55.28 1.17.28 1.85 0 .23-.07.4-.21.52-.15.11-.36.17-.63.17H9.84v-1.4h4.54l-.29.24c0-.49-.07-.9-.21-1.22a1.58 1.58 0 0 0-.63-.76c-.27-.16-.6-.25-1-.25-.44 0-.82.1-1.13.3-.31.21-.55.5-.72.89-.17.38-.25.85-.25 1.39v.14c0 .91.21 1.58.63 2.02.43.43 1.07.64 1.9.64a5.28 5.28 0 0 0 2.04-.45c.28-.13.52-.17.74-.12.22.03.38.13.5.29.12.15.19.33.2.54.03.2-.02.4-.12.6-.11.2-.3.36-.54.5a6.36 6.36 0 0 1-2.86.68Z"
    />
  </svg>
);
export default SvgEsim;
